var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchFilled = function SvgSearchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.007 20.01a9.96 9.96 0 0 0 6.33-2.26l5.968 5.968a1 1 0 0 0 1.414-1.415l-5.967-5.968c3.496-4.279 2.86-10.581-1.418-14.077S5.753-.602 2.257 3.676c-3.495 4.278-2.86 10.58 1.418 14.077a10 10 0 0 0 6.332 2.257"
  })));
};
export default SvgSearchFilled;